module.exports = __webpack_public_path__ + "img/格物钛.19c1a994.png";